import { createContext, useContext, useEffect, useState } from "react";
import { setAuthToken, clearAuthToken } from "../utils/tokenStorage";
import config from "../config";
import { clearRefreshTokenExpiry } from "../utils/sessionExpiry";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const localStorageRefreshToken = localStorage.getItem("refreshToken");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  async function checkSession() {
    try {
      const response = await fetch(`${config.API_BASE_URL}auth/refresh`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          localStorageRefreshToken: localStorageRefreshToken,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        setAuthToken(data.accessToken);
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        throw new Error("Session invalid");
      }
    } catch (error) {
      console.warn("Session check failed:", error.message);
      clearAuthToken();
      clearRefreshTokenExpiry();
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
